module.exports = __webpack_public_path__ + "static/media/homelogo.3e9278e7.png";